module.exports = __webpack_public_path__ + "img/1-1.9e766a44.png";